<template>
    <div>
        <h5>License</h5>
        <div class="card">
            <Button label="Create a License" @click="formDialog = true" />
        </div>
        <!-- license table -->
        <license-table />
        <!-- license form -->
        <license-form v-if="formDialog" @hide-dialog="formDialog = false" />
    </div>
</template>

<script setup>
import LicenseTable from '../components/LicenseTable.vue';
import LicenseForm from '../components/LicenseForm.vue';
import { ref, onMounted } from 'vue';

import { licenseStore, companyStore, userStore } from '@/store/global-stores';

const formDialog = ref(false);

onMounted(async () => {
    await licenseStore.getAllLicenses();
    // initiate years, months and periods to be used in forms
    await licenseStore.loadDates();
    // load all companies JUST IN CASE: License uses company details so
    await companyStore.getCompanies();
    // load all available users
    await userStore.fetchAllUsers({}, true);
});
</script>
